<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaConfigurazione">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione</label>
                        <b-form-input v-model="filtroConfigurazioneParametriVitali.descrizione" type="search" id="codice" placeholder="Inserire descrizione..."></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-parametri-vitali-presidio-list-component ref="cmpConfigurazioneParametriList" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneParametriVitaliPresidioListComponent from "../components/RsaConfigurazioneParametriVitaliPresidioListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneParametriVitaliPresidioListComponent },
    data() {
        return {
            pathResource: "",
            btnConfigurazioniVisible: true,
            showModalLoading: false,
            linkConfigurazioni: "/configurazioni",
            filtroConfigurazioneParametriVitali: { descrizione: null },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazioneParametriVitali"]) {
            me.filtroConfigurazioneParametriVitali = JSON.parse(sessionStorage["filtroConfigurazioneParametriVitali"]);
        }
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioneParametriList.loadParametriVitaliData();
        },
        onClickNuovaConfigurazione() {
            let me = this;
            me.$refs.cmpConfigurazioneParametriList.onClickNuovoParametroVitale();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onRefresh() {
            let me = this;
            me.$refs.cmpConfigurazioneParametriList.loadParametriVitaliData();
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneParametriVitali = { descrizione: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneParametriVitali"] = JSON.stringify(me.filtroConfigurazioneParametriVitali);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneParametriVitali"] = JSON.stringify(me.filtroConfigurazioneParametriVitali);
            me.loadData();
        },
    },
};
</script>
